import actions from "actions";
import Pagination from "components/Pagination/TablePagination";
import constants from "constants";
import React, { Component } from "react";
import { connect } from "react-redux";

const { MODAL_TYPE_DASHBOARD } = constants;
const { getStudyGroupStatistic, showDashboardModalSaga } = actions;

const labels = [
  {
    label: "WEBINAR",
    textAlign: "left",
  },
  {
    label: "№ OF PARTICIPANTS (live)",
    textAlign: "center",
  },
  {
    label: "№ OF VIEWS (recorded)",
    textAlign: "center",
  },
  {
    label: "№ OF CERTS DOWNLOADED",
    textAlign: "center",
  },
  {
    label: "№ OF USERS COMPLETING QUIZ",
    textAlign: "center",
  },
  {
    label: "№ IN-PERSON ATTENDEES",
    textAlign: "center",
  },
];

class StudyGroupSuperhostStatistic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 50,
      group_id: props.params.id,
    };
  }

  componentDidMount() {
    this.props.getStudyGroupStatistic(this.state);
  }

  showUsersModal = (webinar_id, type, additional = {}) => {
    this.props.showUsersModal(
      {
        webinar_id,
        type,
      },
      additional
    );
  };

  onChangePage = (page) =>
    this.setState({ page }, () =>
      this.props.getStudyGroupStatistic(this.state)
    );

  render() {
    const {
      groupStatistic: { totalPages, data },
    } = this.props;

    const { page } = this.state;

    return (
      <div style={{ width: "90%", margin: "auto" }}>
        <div style={{ width: "100%", overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                {labels.map(({ label, textAlign }, idx) => (
                  <th key={idx} style={{ textAlign }}>
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((web) => (
                <Webinar
                  showUsersModal={this.showUsersModal}
                  webinar={web}
                  key={web.id}
                />
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          onChangePage={this.onChangePage}
          page={page}
          total_pages={totalPages}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  groupStatistic: state.studygroups.statistic,
});

const mapDispatchToProps = (dispatch) => ({
  getStudyGroupStatistic: (data) => dispatch(getStudyGroupStatistic(data)),
  showUsersModal: (contentProps, additional = {}) =>
    dispatch(
      showDashboardModalSaga(MODAL_TYPE_DASHBOARD, contentProps, additional)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostStatistic);

const Webinar = ({ webinar, showUsersModal }) => {
  const {
    id,
    webinar_title,
    attended_count,
    views_count,
    downloads_count,
    completed_counts,
    in_person_count,
  } = webinar;

  const showModal = (value, { id, type }) =>
    value ? showUsersModal(id, type, { id, type }) : undefined;

  const getStyles = (value) => value != 0 && showUsersModal && "link-style";

  const info = [
    {
      value: attended_count,
      type: "attended",
    },
    {
      value: views_count,
      type: "viewed",
    },
    {
      value: downloads_count,
      type: "downloaded",
    },
    {
      value: completed_counts,
      type: "completed",
    },
    {
      value: in_person_count,
      type: "attended",
    },
  ];

  return (
    <tr>
      <td>{webinar_title}</td>
      {info.map(({ type, value }, idx) => (
        <td key={idx} style={{ textAlign: "center" }}>
          <span
            className={getStyles(value)}
            onClick={() => showModal(value, { id, type })}
          >
            {value}
          </span>
        </td>
      ))}
    </tr>
  );
};



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostStatistic.jsx